import React from 'react';
import { Button, Dialog, DialogTitle, DialogActions } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import CancelIcon from '@material-ui/icons/Cancel';

const DeletePredictionsDialog = ({
  classes = {},
  predictionsToDeleteSize = 0,
  onConfirm = () => {},
  handleClose = () => {},
}) => {
  const setOnConfirmToTrue = () => {
    if (predictionsToDeleteSize === 1) {
      onConfirm();
    }
    return 'something must be returned';
  };

  return predictionsToDeleteSize === 1 ? (
    setOnConfirmToTrue()
  ) : (
    <Dialog open={!!predictionsToDeleteSize} onClose={handleClose}>
      <DialogTitle>
        {`Are you sure you want to delete ${predictionsToDeleteSize} samples?`}
      </DialogTitle>
      <DialogActions>
        <Button
          className={classes.redButton}
          endIcon={<DeleteIcon />}
          variant="contained"
          disableElevation
          onClick={onConfirm}
        >
          Yes
        </Button>
        <Button
          className={classes.blueButton}
          endIcon={<CancelIcon />}
          variant="contained"
          disableElevation
          onClick={handleClose}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePredictionsDialog;
